import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'

import apiAuth from '@/apis/auth'

import { setToken, removeToken } from '@/utils/auth'
import { setProfile, removeProfile } from '@/utils/profile'

import { version } from '../package'

Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  token: '',
  user: {},
  version: version
}

const actions = {
  login({}, { user, pass }) {
    return new Promise((resolve, reject) => {
      apiAuth.login({ user, pass }).then(
        (data) => {
          // commit('loginSuccess', data.token)
          if (data.code === 0) {
            setToken(data.data.token)
            setProfile(data.data.user)

            router.push('/')

            resolve()
          } else {
            reject(data.message)
          }
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  logout({}) {
    removeToken()
    removeProfile()

    router.push('/login')
  }
}

const mutations = {
  toggleSidebarDesktop(state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile(state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set(state, [variable, value]) {
    state[variable] = value
  }
}

export default new Vuex.Store({
  state,
  mutations,
  actions
})
